import React, { useState } from 'react';
import { Button, Col, Row } from 'antd';
import {
  WorkGroupOfTwoCard,
  WorkGroupOfFourCard,
  WorkGroupOfThreeCard,
} from '@BUP/components';
import { useTranslation } from 'react-i18next';
import styles from './work-groups-container.module.css';

const WorkGroupsContainer = ({
  groupPartition2,
  groupPartition3,
  groupPartition4,
}) => {
  const [buttonState, setButtonState] = useState(0);

  const handleClickButton1 = () => {
    setButtonState(1);
  };

  const handleClickButton2 = () => {
    setButtonState(2);
  };

  const handleClickButton3 = () => {
    setButtonState(3);
  };
  const [t] = useTranslation();
  return (
    // <div>
    <Row className={styles.container}>
      <Col sm={24} lg={20} xxl={21} className={styles.cards_container}>
        <Row
          gutter={[24, 0]}
          // type="flex"
          // justify="between"
          className={styles.cards_wrapper}
        >
          {buttonState === 0 || buttonState === 1
            ? groupPartition2?.map((group) => (
                <Col xxl={6} className={styles.workgroup_wrapper}>
                  <WorkGroupOfTwoCard
                    key={group[0]?.enrollmentId}
                    dataGroup={group}
                  />
                </Col>
              ))
            : buttonState === 2
            ? groupPartition3?.map((group) => (
                <Col xxl={8}>
                  <WorkGroupOfThreeCard
                    key={group[0]?.enrollmentId}
                    dataGroup={group}
                  />
                </Col>
              ))
            : groupPartition4?.map((group) => (
                <Col xxl={12}>
                  <WorkGroupOfFourCard
                    key={group[0]?.enrollmentId}
                    dataGroup={group}
                  />
                </Col>
              ))}
        </Row>
      </Col>
      <Col sm={24} lg={4} xxl={3} className={styles.button_groups_container}>
        <Button
          shape="round"
          className={styles.button_groups}
          onClick={handleClickButton1}
        >
          {t('pages.data.dashBoardSociogram.group2Text')}
        </Button>
        <Button
          shape="round"
          className={styles.button_groups}
          onClick={handleClickButton2}
        >
          {t('pages.data.dashBoardSociogram.group3Text')}
        </Button>
        <Button
          shape="round"
          className={styles.button_groups}
          onClick={handleClickButton3}
        >
          {t('pages.data.dashBoardSociogram.group4Text')}
        </Button>
      </Col>
    </Row>
    // </div>
  );
};

export default WorkGroupsContainer;
